export const RIGHT_ARROW = 39;
export const LEFT_ARROW = 37;
export const ENTER = 13;
export const BACKSPACE = 8;
export const DELETE = 46;
export const A = 65;
